exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style-module__eerC___3Cbwz {\n  background: white;\n  padding: 24px;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  -ms-flex-negative: 1;\n  flex-shrink: 1;\n  -ms-flex-preferred-size: auto;\n  flex-basis: auto;\n  display: -ms-flexbox;\n  display: flex; }\n\n.style-module__eerContent___2SPlE {\n  width: 100%;\n  min-width: 400px;\n  min-height: 150px;\n  background-color: white;\n  border: 1px dashed #eee; }\n\n.style-module__successNotification___1JBqy {\n  background: rgba(255, 255, 255, 0.95) !important;\n  border-right: 4px solid;\n  border-color: #00a854; }\n\n.style-module__infoNotification___1qDPl {\n  background: rgba(255, 255, 255, 0.95) !important;\n  border-right: 4px solid;\n  border-color: #108ee9; }\n\n.style-module__warningNotification___32uQo {\n  background: rgba(255, 255, 255, 0.95) !important;\n  border-right: 4px solid;\n  border-color: #ffbf00; }\n\n.style-module__errorNotification___2zHv6 {\n  background: rgba(255, 255, 255, 0.95) !important;\n  border-right: 4px solid;\n  border-color: #f04134; }\n", ""]);

// exports
exports.locals = {
	"eerC": "style-module__eerC___3Cbwz",
	"eerContent": "style-module__eerContent___2SPlE",
	"successNotification": "style-module__successNotification___1JBqy",
	"infoNotification": "style-module__infoNotification___1qDPl",
	"warningNotification": "style-module__warningNotification___32uQo",
	"errorNotification": "style-module__errorNotification___2zHv6"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]&-raw!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/pages/EER/style.module.scss
// module id = 1070
// module chunks = 0